
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const settingsApi = createAsyncThunk("settings", async () => {
  const response = await axiosInstance.get("/settings");
  return response.data;
});

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    settings: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(settingsApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(settingsApi.fulfilled, (state, action) => {
        state.settings = action.payload;
        state.loading = false;
      })
      .addCase(settingsApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default settingsSlice.reducer;
